export default "__VITE_ASSET__e745daaa__"